import { EVENTS } from 'Constants/intercom'

import {
  handlers as commonHandlers,
  onComponentDidMount as onComponentDidMountCommon,
  onComponentDidUpdate as onComponentDidUpdateCommon,
} from './common'

import {
  childHandlers as childHandlersForUser,
  mapStateToProps as mapStateToPropsForUser,
  onComponentDidUpdate as onComponentDidUpdateForUser,
} from './user'

import {
  handlers as handlersForLedger,
  mapStateToProps as mapStateToPropsForLedger,
  onComponentDidUpdate as onComponentDidUpdateForLedger,
} from './ledger'

import {
  handlers as handlersForReport,
  mapStateToProps as mapStateToPropsForReport,
  onComponentDidUpdate as onComponentDidUpdateForReport,
} from './report'

import {
  handlers as handlersForVendor,
  mapStateToProps as mapStateToPropsForVendor,
  onComponentDidUpdate as onComponentDidUpdateForVendor,
} from './vendor'

import {
  mapStateToProps as mapStateToPropsForSession,
  onComponentDidUpdate as onComponentDidUpdateForSession,
} from './session'

import {
  handlers as handlersForSubscription,
  mapStateToProps as mapStateToPropsForSubscribe,
  onComponentDidUpdate as onComponentDidUpdateForSubscribe,
} from './subscribe'

import {
  handlers as handlersForUploadFile,
  childHandlers as childHandlersForUploadFile,
  mapStateToProps as mapStateToPropsForUploadFile,
} from './uploadFile'

export const mapStateToProps = (state) => ({
  ...mapStateToPropsForUser(state),
  ...mapStateToPropsForLedger(state),
  ...mapStateToPropsForReport(state),
  ...mapStateToPropsForVendor(state),
  ...mapStateToPropsForSession(state),
  ...mapStateToPropsForSubscribe(state),
  ...mapStateToPropsForUploadFile(state),
})

export const handlers = () => ({
  ...commonHandlers(EVENTS),
  ...handlersForVendor(EVENTS),
  ...handlersForReport(EVENTS),
  ...handlersForLedger(EVENTS),
  ...handlersForUploadFile(EVENTS),
  ...handlersForSubscription(EVENTS),
})

export const childHandlers = () => ({
  ...childHandlersForUser(EVENTS),
  ...childHandlersForUploadFile(EVENTS),
})

export const onComponentDidMount = (props) => onComponentDidMountCommon(props)

export const onComponentDidUpdate = (prevProps, props) => {
  onComponentDidUpdateCommon(prevProps, props)
  onComponentDidUpdateForUser(prevProps, props)
  onComponentDidUpdateForLedger(prevProps, props)
  onComponentDidUpdateForReport(prevProps, props)
  onComponentDidUpdateForVendor(prevProps, props)
  onComponentDidUpdateForSession(prevProps, props)
  onComponentDidUpdateForSubscribe(prevProps, props)
  props.updateTrackedFiles()
}
